import { render, staticRenderFns } from "./home-en.vue?vue&type=template&id=4ba2d1ec&"
import script from "./home-en.vue?vue&type=script&lang=js&"
export * from "./home-en.vue?vue&type=script&lang=js&"
import style0 from "./home-en.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports